import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Form, Modal } from 'antd';

import OTPInput from '../../components/OTPInput';

import { addCounter, addUserData } from '../../store/reducer/accountSlice';
import { forgotPinPasswordLinkApi } from '../../services/authApi/forgotPinApi';
import { validatePin } from '../../services/authApi/authApi';

import { toastNotify } from '../../utils/toastNotify';

const ReEnterPin = () => {
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const [openPINModal] = useState(true);

  const [pin, setPin] = useState('');
  const [loading, setLoading] = useState(false);
  const [forgotPinLoading, setForgotPinLoading] = useState(false);

  const handleEnterPin = async (pin) => {
    setPin(pin);
    if (pin.length === 4) {
      let formData = {
        pin: pin,
        pinVerificationType: 'login',
      };
      try {
        const userData = await validatePin(formData);
        if (!userData.isError) {
          await dispatch(addUserData({ userData: userData?.data?.user, isPinEntered: true }));
          await dispatch(addCounter(userData?.data?.counter));
          localStorage.setItem('access_token', userData?.data?.accessToken);
          localStorage.removeItem('access_token_temp');
          const redirectPath = localStorage.getItem('redirectIntendedPage');
          if (redirectPath && redirectPath !== '/' && redirectPath !== '/login') {
            navigate(redirectPath, { replace: true });
            localStorage.removeItem('redirectIntendedPage');
          } else if (localStorage.getItem('prev_pathname')) {
            navigate(localStorage.getItem('prev_pathname'), { replace: true });
            localStorage.removeItem('prev_pathname');
          } else {
            navigate('/', { replace: true });
          }
          setLoading(false);
          localStorage.removeItem('counter');
        } else {
          setLoading(false);
          toastNotify('error', userData?.message);
          setPin('');
        }
      } catch (error) {
        const { response } = error;
        toastNotify('error', response?.data?.message);
        setLoading(false);
        setPin('');
      }
    }
  };

  const sendVerificationLink = async () => {
    const formData = {
      email: localStorage.getItem('email'),
      credentialType: 'pinAndPassword',
    };
    setForgotPinLoading(true);
    try {
      const userData = await forgotPinPasswordLinkApi(formData);
      if (!userData.isError) {
        navigate('/forgot-pin/request-reset');
        setForgotPinLoading(false);
        localStorage.removeItem('counter');
      } else {
        setForgotPinLoading(false);
        toastNotify('error', userData?.message);
      }
    } catch (error) {
      const { response } = error;
      toastNotify('error', response?.data?.message);
      setForgotPinLoading(false);
    }
  };

  return (
    <>
      {openPINModal && (
        <Modal open={openPINModal} width={524} closable={false} footer={false} centered mask={false} maskClosable={false} keyboard={false}>
          <h4 className='text-center fz-24 fw-700 mb-16'>Welcome back!</h4>
          <p className='mb-48 text-center'>Enter your 4-digit PIN to access your Realbricks account.</p>
          <Form className='pin-form details-form' autoComplete='off'>
            <OTPInput
              length={4}
              onChangeOTP={(otp) => handleEnterPin(otp)}
              onClearOtp={pin}
              otp={pin}
              disabled={loading || forgotPinLoading}
              autoFocus
              inputClassName='otp__input'
              className='mb-48 otp'
            />
            <div className='pb-8 pt-8 text-center'>
              <Link
                to={Number(localStorage.getItem('counter')) >= 5 && '../../forgot-pin'}
                onClick={() => Number(localStorage.getItem('counter')) < 5 && sendVerificationLink()}
                className='underline fw-600 text-terracotta text-right'
              >
                I forgot my PIN
              </Link>
            </div>
          </Form>
        </Modal>
      )}
    </>
  );
};

export default ReEnterPin;
